if (document.location.hostname === "localhost") {
  window._y010 = true;
}

import AxL from "./axl.js";
import ArtRemix from "./ArtRemix.js";

window.axl = null;

const NO_AXL = false;

export default class App {
  constructor() {
    window.axl = new AxL();
    window.axl.handshake().then((data) => {
      const artRemix = new ArtRemix();
      artRemix.init(data);      
    });
  }
}
